import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

export default {
  register: vueInstance => {
    Raven.config(
      'https://8bfd13292bd84550aa662081a53e0559@sentry.teamculture.com.br/11',
      {
        release: 'v0.4',
        environment: process.env.NODE_ENV,
        autoBreadcrumbs: {
          xhr: true,
        },
        ignoreUrls: [
          /\/sockjs-node\//i,
          /\/gstatic\//i,
          /extensions\//i,
          /^chrome\/\//i,
          /^gtm\/\//i,
        ],
      }
    )
      .addPlugin(RavenVue, vueInstance)
      .install()

    window.addEventListener('error', trackError, false)
    vueInstance.$on('error', trackError)
  },
}

const trackError = function(error) {
  // console.log(error)
  const e = error.error
  if (e && e.isAxiosError) {
    return
  } else {
    const err = Object.assign({ level: 'error', data: error }, error)
    Raven.captureException(new Error(error), {
      extra: err.data,
      tags: err.tags,
      level: err.level,
    })
  }
}
